"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isApiError;
exports.isStandardError = exports.isOrderBuilderError = void 0;

/**
 * Returns true if the payload is the shape of the `generic_error` model of the Flow API.
 *
 * @param {Object} payload - payload of a redux action
 */
var isStandardError = function isStandardError(payload) {
  return !!(payload && payload.code && payload.messages && payload.messages.length);
};
/**
 * Returns true if the payload is the shape of the `order_buidler` model of the Flow API and the
 * number of errors is greater than zero.
 *
 * @param {Object} payload - payload of a redux action
 */


exports.isStandardError = isStandardError;

var isOrderBuilderError = function isOrderBuilderError(payload) {
  return !!(payload && payload.errors && payload.errors.length);
};
/**
 * Returns true if the payload of an action contains errors in the form of a `generic_error` or
 * errors in the `order_buidler` model.
 */


exports.isOrderBuilderError = isOrderBuilderError;

function isApiError() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var payload = action.payload;
  return isStandardError(payload) || isOrderBuilderError(payload);
}